const searchTrigger = document.querySelectorAll('.js-search-trigger'),
    searchContainer = document.querySelector('.js-site-search');

if (searchTrigger.length && searchContainer) {
    // Pause/Close/Hide video events
    searchContainer.addEventListener('click', closeSearch);

    // Show Search field
    searchTrigger.forEach(el => {
        el.addEventListener('click', showSearch);
    });
}

// Show search lightbox
function showSearch(e) {
    e.preventDefault();

    // Show and fadeIn search container
    searchContainer.style.display = 'block';

    setTimeout(function () {
        searchContainer.classList.add('visible');

        // Auto focus the keywords field
        searchContainer.querySelector('.keywords').focus();
    }, 250);
}

// Hide page overlay
function closeSearch(e) {
    // If we've actually clicked in the keywords/submit field don't
    // fade the container out!
    var $targetItem = e.target;

    if (!$targetItem.classList.contains('keywords') && !$targetItem.classList.contains('.submit')) {
        // Fadeout overlay
        searchContainer.classList.remove('visible');

        // Set overlay to display:none after fadeout
        setTimeout(function () {
            searchContainer.style.display = 'none';
        }, 500); // duration should be >= CSS transition time
    }
}